import styled from 'styled-components';

const SimplifiedEditorWrapper = styled.div`
  .tiptap {
    min-height: unset;
  }
`;

export default SimplifiedEditorWrapper;
